import React, { useEffect, useState, useMemo } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { PageHeader, Card, Loading, Pill, SeverityTag, EmptyState } from "@/components/kit";
import { BadgeCheck } from "lucide-react";

export default function Memberships() {
  const [list, setList] = useState(null);
  const [filter, setFilter] = useState("all");

  useEffect(() => { api.ownerMemberships().then(setList).catch((e) => { toast.error(e.message); setList([]); }); }, []);

  const rows = useMemo(() => (list || []).filter((m) => filter === "all" || m.status === filter), [list, filter]);
  const counts = useMemo(() => {
    const c = { valid: 0, expiring: 0, expired: 0 };
    (list || []).forEach((m) => { c[m.status] = (c[m.status] || 0) + 1; });
    return c;
  }, [list]);

  return (
    <div>
      <PageHeader eyebrow="Owner" title="Membership"
        subtitle="Status membership aktif per kategori, diurutkan berdasarkan yang segera berakhir." />

      <div className="mb-6 flex flex-wrap gap-2">
        {[["all", "Semua"], ["expiring", `Segera Berakhir (${counts.expiring})`], ["valid", `Aktif (${counts.valid})`], ["expired", `Berakhir (${counts.expired})`]].map(([v, l]) => (
          <Pill key={v} active={filter === v} onClick={() => setFilter(v)}>{l}</Pill>
        ))}
      </div>

      {list === null ? <Loading /> : !rows.length ? (
        <EmptyState icon={BadgeCheck} title="Tidak ada membership" />
      ) : (
        <div className="space-y-3">
          {rows.map((m, i) => (
            <Card key={i} className="flex items-center justify-between" data-testid="membership-row">
              <div>
                <div className="text-white">{m.member_name}</div>
                <div className="mt-1 text-[12px] text-[#8E8E93]">{m.category} · berakhir {formatDate(m.expires_at)}</div>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-sm text-[#A1A1A6]">{m.days_left}h</span>
                <SeverityTag value={m.status} />
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
